var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-cascader',{attrs:{"placeholder":"根据地区筛选","options":_vm.regions,"filterable":"","props":{ checkStrictly: true }},on:{"change":_vm.RegionChangeSearch},model:{value:(_vm.selected_values),callback:function ($$v) {_vm.selected_values=$$v},expression:"selected_values"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }